// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"a2136d9f","787":"b6414357"}[chunkId] + ".chunk.js";
};